import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable import/no-cycle */
import React, { useMemo, useState, useCallback } from "react";
import Box from "../Box";
import ClearInputIcon from "@pixel/assets/icons/ClearInput";
import TextField from "../TextField";
import { createEmptyAppliedFilter } from '.';
const ListFilterText = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter,
    ariaLabeledBy
  } = _ref;
  const [expanded, setExpanded] = useState(false);
  const appliedFilterValues = useMemo(() => {
    return (appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues.length) > 0 ? appliedSearchFilter.filterValues : [];
  }, [appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues //needed to shallow compare changes
  ]);
  const handleChangeValue = useCallback(e => {
    const value = e.target.value;
    if (value != null) {
      const filterValues = []; //Note: even though its single select we commonize the way we pass back data in an array
      const filterValue = {
        value: value,
        label: value,
        context: null
      };
      filterValues.push(filterValue);
      const newAppliedSearchFilter = appliedSearchFilter ? appliedSearchFilter : createEmptyAppliedFilter(searchFilter);
      newAppliedSearchFilter.filterValues = filterValues;
      newAppliedSearchFilter.displayLabel = "".concat(searchFilter.label, ": ").concat(value);
      onChangeAppliedFilter(searchFilter, newAppliedSearchFilter);
    } else {
      onChangeAppliedFilter(searchFilter, null);
    }
  }, [searchFilter, appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues,
  //needed to shallow compare changes 
  onChangeAppliedFilter, createEmptyAppliedFilter]);
  const handleClear = e => {
    onChangeAppliedFilter(searchFilter, null);
  };
  const value = (appliedFilterValues === null || appliedFilterValues === void 0 ? void 0 : appliedFilterValues.length) > 0 ? appliedFilterValues[0].value : "";
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "".concat(searchFilter.id),
    fullWidth: true,
    type: "text",
    onChange: handleChangeValue,
    label: null,
    ariaLabel: searchFilter.label,
    value: value,
    placeholder: searchFilter.placeholder,
    maxLength: searchFilter.maxLength,
    endingButtonProps: {
      ariaLabel: "Clear",
      icon: ClearInputIcon,
      onClick: handleClear
    }
  }));
});
export default ListFilterText;